import { IString } from '../../../model';
import { FieldType, FilterOpt, IConfigField, IValue } from '../model';

export const getAllowClearConfig = (filterOptExtension?: FilterOpt) => {
  if (!filterOptExtension) {
    return true;
  }
  return filterOptExtension.allowClear || false;
};

export const getPlaceholderConfig = <T>(fieldConfig: IConfigField<T>) => {
  if (!fieldConfig.filterOptExtension) {
    return fieldConfig.name;
  }
  return fieldConfig.filterOptExtension.placeholder || fieldConfig.name;
};

export const getSelectTypeConfig = (
  filterOptExtension?: FilterOpt | undefined
) => {
  if (
    filterOptExtension?.kind === FieldType.select ||
    filterOptExtension?.kind === FieldType.select_multiple ||
    filterOptExtension?.kind === FieldType.select_group ||
    filterOptExtension?.kind === FieldType.advanced_select ||
    filterOptExtension?.kind === FieldType.advanced_select_multiple ||
    filterOptExtension?.kind === FieldType.tree_select
  ) {
    return filterOptExtension.type || 'default';
  }
  return 'default';
};

export const getFilterValue = <T>(
  field: IConfigField<T>,
  filterValues: IString<IValue>
) => {
  if (!field.key) {
    return '';
  }
  const item = filterValues[field.key];
  const value = item ? item.value : getDefaultValueByType(field);
  return value;
};

export const getDefaultValueByType = <T>(field: IConfigField<T>) => {
  const { filterOptExtension } = field;
  if (!filterOptExtension) {
    return '';
  }

  switch (filterOptExtension.kind) {
    case FieldType.select_multiple:
    case FieldType.date_range:
    case FieldType.advanced_select_multiple:
    case FieldType.tree_select:
      return [];
    default:
      return '';
  }
};

export const getClassNameByFieldKey = (key: string) => {
  if (!key) {
    return '';
  }
  return key.trim().toLocaleLowerCase().replace(/_/g, '-');
};

export const getFilterableFields = <T>(
  configFields: ReadonlyArray<IConfigField<T>>,
  filterFieldKey?: ReadonlyArray<string>
) => {
  // 字段配置的排序不影响过滤条件的排序
  if (filterFieldKey) {
    const oField: IString<IConfigField<T>> = {};
    configFields.forEach((item) => {
      oField[item.key] = item;
    });
    const fields: IConfigField<T>[] = [];
    filterFieldKey.forEach((key) => {
      const field = oField[key];
      if (!field) {
        return;
      }
      if (
        (field.filterOptExtension &&
          field.filterOptExtension.filterable === undefined) ||
        field.filterOptExtension?.filterable
      ) {
        fields.push(field);
      }
    });
    return fields;
  }

  return configFields.filter(
    (item) =>
      (item.filterOptExtension &&
        item.filterOptExtension.filterable === undefined) ||
      item.filterOptExtension?.filterable
  );
};

// 获取搜索条件的空值
export const getFieldEmptyValue = <T>(configField: IConfigField<T>) => {
  const filterType = configField.filter_type;
  switch (filterType) {
    case FieldType.text:
    case FieldType.textarea:
    case FieldType.date:
    case FieldType.user_chooser:
    case FieldType.select:
    case FieldType.radio:
    case FieldType.select_group:
    case FieldType.advanced_select:
      return getValueTemplate(configField.key, '');
    case FieldType.cascader_multiple:
    case FieldType.select_multiple:
    case FieldType.user_chooser_multiple:
    case FieldType.date_range:
    case FieldType.checkbox:
    case FieldType.advanced_select_multiple:
      return getValueTemplate(configField.key, []);
    case FieldType.tree_select:
      return getValueTemplate(configField.key, '');
    default:
      return null;
  }
};

const getValueTemplate = (key: string, value: any): IString<IValue> => {
  return {
    [key]: {
      key,
      value,
    },
  };
};
